<kiene-kiene-table [tableDescriptor]="tableDescriptor" [kunde_id]="kunde_id"></kiene-kiene-table>
